import { useEffect, useMemo, useState } from "react";
import { X } from "lucide-react";

const CONFIRM_TEXT = "DELETE";

export default function DeleteAttendeesDialog({ open, onClose, count, namesPreview = [], onConfirm, busy }) {
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (open) setTyped("");
  }, [open, count]);

  const canDelete = typed.trim() === CONFIRM_TEXT;
  const title = count === 1 ? "Delete attendee" : `Delete ${count} attendees`;
  const preview = useMemo(() => namesPreview.filter(Boolean).slice(0, 5), [namesPreview]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-labelledby="delete-attendees-title">
      <div className="surface w-full max-w-md border border-[#EF4444]/40 p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 id="delete-attendees-title" className="font-heading text-xl text-[#EF4444]">
              {title}
            </h2>
            <p className="text-sm text-[var(--text-secondary)] mt-2">
              This permanently removes {count === 1 ? "this person" : `these ${count} people`} and their activity history.
              This cannot be undone.
            </p>
          </div>
          <button type="button" className="btn-ghost p-2" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        {preview.length ? (
          <ul className="mt-4 text-xs font-mono text-[var(--text-tertiary)] space-y-1 max-h-24 overflow-y-auto">
            {preview.map((line) => (
              <li key={line}>{line}</li>
            ))}
            {count > preview.length ? <li>…and {count - preview.length} more</li> : null}
          </ul>
        ) : null}

        <label className="block mt-5 text-xs text-[var(--text-secondary)]">
          Type <span className="font-mono text-[var(--text-primary)]">{CONFIRM_TEXT}</span> to enable delete
          <input
            className="input-dark w-full mt-2 font-mono"
            value={typed}
            onChange={(ev) => setTyped(ev.target.value)}
            placeholder={CONFIRM_TEXT}
            autoComplete="off"
            data-testid="delete-attendees-confirm-input"
          />
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary bg-[#EF4444] hover:bg-[#DC2626] border-[#EF4444] disabled:opacity-40"
            disabled={!canDelete || busy}
            onClick={onConfirm}
            data-testid="delete-attendees-confirm-btn"
          >
            {busy ? "Deleting…" : count === 1 ? "Delete attendee" : `Delete ${count} attendees`}
          </button>
        </div>
      </div>
    </div>
  );
}
